import { userInfoApi, UserInformation } from '../state/user_info';

export const useAuthUser = (): UserInformation | undefined => {
    const state = userInfoApi.endpoints.userInfo.useQueryState(null);
    return state.data;
};
